import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
interface Buyer {
  name: string;
  city: string;
}
const buyers: Buyer[] = [{
  name: 'María José',
  city: 'Buenos Aires'
}, {
  name: 'Lucía',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Valeria',
  city: 'Mendoza'
}, {
  name: 'Carolina',
  city: 'La Plata'
}, {
  name: 'Florencia',
  city: 'Mar del Plata'
}, {
  name: 'Gabriela',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Marcela',
  city: 'Salta'
}, {
  name: 'Patricia',
  city: 'Santa Fe'
}, {
  name: 'Natalia',
  city: 'Neuquén'
}, {
  name: 'Romina',
  city: 'San Juan'
}, {
  name: 'Andrea',
  city: 'Paraná'
}, {
  name: 'Padre Marcos',
  city: 'Corrientes'
}, {
  name: 'Verónica',
  city: 'Bahía Blanca'
}, {
  name: 'Daniela',
  city: 'Posadas'
}, {
  name: 'Cecilia',
  city: 'Resistencia'
}, {
  name: 'Laura',
  city: 'San Luis'
}, {
  name: 'Mónica',
  city: 'Río Cuarto'
}];
const offers: string[] = ['MegaKit de Catequesis Infantil', 'MegaKit de Catequesis Infantil PRO'];
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
// Random delay between 40s and 60s
const nextDelay = () => 40000 + Math.random() * 20000;
interface Notice extends Buyer {
  offer: string;
}
export function PurchaseNotification() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    const clearAll = () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
    const schedule = (delay: number) => {
      const showT = setTimeout(() => {
        const buyer = pick(buyers);
        setNotice({
          ...buyer,
          offer: pick(offers)
        });
        // auto-hide after 5.5s, then schedule the next one
        const hideT = setTimeout(() => {
          setNotice(null);
          schedule(nextDelay());
        }, 5500);
        timers.current.push(hideT);
      }, delay);
      timers.current.push(showT);
    };
    // first popup appears a bit sooner so the buyer notices the pattern
    schedule(6000);
    return clearAll;
  }, []);
  return <div aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[88vw] sm:max-w-sm pointer-events-none" data-id="element-220">
      <AnimatePresence data-id="element-221">
        {notice && <motion.div role="status" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white border border-gold-500/40 rounded-2xl shadow-[0_12px_40px_-12px_rgba(30,58,95,0.4)] p-3 pr-9 flex items-center gap-3 relative" data-id="element-222">
            <button onClick={() => setNotice(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-navy-900/40 hover:text-navy-900 transition-colors" data-id="element-223">
              <X className="w-4 h-4" data-id="element-224" />
            </button>

            <div className="shrink-0 w-11 h-11 rounded-full bg-navy-950 flex items-center justify-center" data-id="element-225">
              <BadgeCheck className="w-6 h-6 text-gold-500" data-id="element-226" />
            </div>

            <div className="min-w-0" data-id="element-227">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-228">
                <span className="text-[10px] font-bold uppercase tracking-wider text-gold-600" data-id="element-229">
                  Compra verificada
                </span>
                <span className="w-1 h-1 rounded-full bg-navy-900/30" data-id="element-230" />
                <span className="text-[10px] text-navy-900/50" data-id="element-231">
                  hace un momento
                </span>
              </div>
              <p className="text-sm text-navy-900 leading-snug" data-id="element-232">
                <span className="font-bold" data-id="element-233">{notice.name}</span> de{' '}
                <span className="font-medium" data-id="element-234">{notice.city}</span> compró el{' '}
                <span className="font-semibold text-navy-900" data-id="element-235">
                  {notice.offer}
                </span>
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}